import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import useAxios from "./../../Hooks/useAxios";

import PatientInfo from "./patientInfo";
import DoctorNotes from "./doctorNotes";
import Vitals from "./vitals";
import Investigations from "./Investigation";
import Procedure from "./procedure";
import Prescription from "./prescription";

function MedicalHistory() {
  const [visits, setVisits] = useState([]);

  const request = useAxios();

  const params = useParams();

  const getVisits = async () => {
    const res = await request({
      method: "GET",
      url: "chapchap/list/visits",
      params: {
        "patient_id-int": params.id,
        limit: 1000000,
      },
      showSuccessModal: false,
    });
    //

    if (res._error) return;
    setVisits(Array.isArray(res?.data?.docs) ? res?.data?.docs : visits);
  };

  useEffect(() => {
    getVisits();
  }, []);

  return (
    <div className=" w-full h-full p-4 ">
      <PatientInfo />
      <Vitals visits={visits} />
      <DoctorNotes visits={visits} />
      <Investigations visits={visits} />
      <Procedure visits={visits} />
      <Prescription visits={visits} />
    </div>
  );
}

export default MedicalHistory;
